import React from "react";
import { Backdrop } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Skeleton from "@material-ui/lab/Skeleton";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function Loader({ open }) {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={!!open}>
      <Skeleton variant="rect" />
    </Backdrop>
  );
}
Loader.propTypes = {
  open: PropTypes.bool,
};
